import {
  requestSvgIcon
} from "./anacapri-chunk.6ACCZVJX.js";
import {
  getCssColorString
} from "./anacapri-chunk.5VHHJTWD.js";
import {
  FAIcon,
  LobIconMetadata,
  isLobIconName
} from "./anacapri-chunk.WSUAZTLZ.js";
import {
  base_default,
  n,
  r
} from "./anacapri-chunk.3P6V43X6.js";
import {
  AnacapriElement
} from "./anacapri-chunk.3HZGRT44.js";
import {
  customElement_default
} from "./anacapri-chunk.YC5RXRZP.js";
import {
  LogHandler_default,
  Logger_default
} from "./anacapri-chunk.J7V767XI.js";
import {
  le
} from "./anacapri-chunk.7RHBWUIW.js";
import {
  e
} from "./anacapri-chunk.KFS2QL2B.js";
import {
  i
} from "./anacapri-chunk.TOMZZDRF.js";
import {
  D,
  ke
} from "./anacapri-chunk.37PM4VTN.js";
import {
  __decorateClass
} from "./anacapri-chunk.AHXTNXK6.js";

// node_modules/lit-html/directives/unsafe-svg.js
var pe = class extends le {
};
pe.directiveName = "unsafeSVG", pe.resultType = 2;
var fe = e(pe);

// node_modules/@anacapri/boons/chunks/anacapri-chunk.LHXTYQUM.js
var Logger_default2 = new LogHandler_default(
  parseInt(2),
  `[${"@anacapri/boons"}]: `
);

// node_modules/@anacapri/boons/chunks/anacapri-chunk.HOHPOCIU.js
var AnacapriStore = class {
  constructor(store, namespace = "anacapri--") {
    this.store = store === "local" ? window.localStorage : window.sessionStorage;
    this.isAvailable = this.isStorageAvailable();
    this.namespace = namespace;
  }
  isStorageAvailable() {
    try {
      const x = "__storage_test__";
      this.store.setItem(x, x);
      this.store.removeItem(x);
      return true;
    } catch (e2) {
      Logger_default2.logWarning(`Storage isn't available. Failed with error: ${e2}`);
      return false;
    }
  }
  setItem(key, value) {
    if (this.isAvailable) {
      try {
        this.store.setItem(`${this.namespace}${key}`, value);
      } catch (e2) {
        Logger_default2.logWarning(`Could not write to the store. Failed with error: ${e2}`);
      }
    }
  }
  getItem(key) {
    if (this.isAvailable) {
      try {
        return this.store.getItem(`${this.namespace}${key}`);
      } catch (e2) {
        Logger_default2.logWarning(`Could not remove item from the store. Failed with error: ${e2}`);
      }
    }
    return null;
  }
  removeItem(key) {
    if (this.isAvailable) {
      try {
        this.store.removeItem(`${this.namespace}${key}`);
      } catch (e2) {
        Logger_default2.logWarning(`Could not remove item from the store. Failed with error: ${e2}`);
      }
    }
  }
  clear() {
    if (this.isAvailable) {
      this.store.clear();
    }
  }
};
var store_default = AnacapriStore;
var sessionStorage_default = new store_default("session");
var logHandler = new LogHandler_default(4, "@anacapri/boons [UserInfo]: ");
var FED_USER_INFO_SERVICE_URL = "/ose/fed/anacapri-api-gateway/user-info";
var LAST_MRH_SESSION_COOKIE_KEY = "LastMRH_Session";
var USER_INFO_SESSION_STORAGE_KEY = "ana-user-info";
var UserInfoService = class {
  /**
   * Currently, init is called by the UserInfoInstance when creating a new UserInfoService.
   * It doesn't do anything above fetching the user info, but we may have a need in the future.
   */
  // @ts-expect-error: Used for testing purposes
  async init() {
    try {
      await this.getUserInfo();
    } catch (error) {
      logHandler.logError(`in init: Failed to initialize UserInfo: 
 ${error}`);
    }
  }
  /**
   * Queries cookies for LastMRH_Session.
   * @returns the LastMRH_Session cookie value, if cookies are supported and the cookie exists, else undefined.
   */
  // eslint-disable-next-line class-methods-use-this
  getLastMRHSessionCookie() {
    let lastMRHSessionCookie = "";
    if (document.cookie) {
      const lastMRHSessionCookieKeyAndValue = document.cookie.split(";").find((cookie) => cookie.startsWith(LAST_MRH_SESSION_COOKIE_KEY));
      if (lastMRHSessionCookieKeyAndValue) {
        const [, value] = lastMRHSessionCookieKeyAndValue.split("=");
        lastMRHSessionCookie = value;
      }
    }
    return lastMRHSessionCookie;
  }
  /**
   * Checks the current session cookie against the session cookie passed in.
   * @param sessionCookie - the stored Last MRH Session cookie
   * @returns true if session cookies match
   */
  isLastMRHSessionCookieUnchanged(sessionCookie) {
    return sessionCookie === this.getLastMRHSessionCookie();
  }
  /**
   * This function isn't intended for use outside testing. It makes it easier to
   * reuse the same user profile service in multiple tests. Essentially, it clears out
   * all cached and session stored data so the next call will fetch from server.
   * @param includingSessionStorage - Include session storage.
   */
  // @ts-expect-error: Used for testing purposes
  clearCache(includingSessionStorage = true) {
    this.userInfo = null;
    this.userInfoRequestPromise = null;
    if (includingSessionStorage) {
      sessionStorage_default.removeItem(USER_INFO_SESSION_STORAGE_KEY);
    }
  }
  /**
   * Wrapper for fetch call that handles setting up and tearing down the userInfoRequestPromise.
   * @returns Promise that resolves to UserInfo
   * @see UserProfile interface above.
   */
  async initializeFetchOfUserInfo() {
    try {
      this.userInfoRequestPromise = this.fetchUserInfo();
      const userInfo2 = await this.userInfoRequestPromise;
      return userInfo2;
    } finally {
      this.userInfoRequestPromise = null;
    }
  }
  /**
   * Fetches User Info from the back-end service and sets the cache and session storage with the response.
   * This is important in the situation where we have multiple instances of UserInfoService in use in the same application.
   * @returns Promise that resolves to UserInfo
   * @see UserInfo interface above.
   * @throws Error - fetch fail
   */
  async fetchUserInfo() {
    const response = await fetch(FED_USER_INFO_SERVICE_URL);
    if (!response.ok) {
      throw new Error(
        `in fetchUserInfo: Fetch user info failed with status: ${response.statusText} (${response.status})`
      );
    }
    const userInfoResponse = await response.json();
    let roles = [];
    if (userInfoResponse.roles) {
      roles = typeof userInfoResponse.roles === "string" ? userInfoResponse.roles.split(",") : userInfoResponse.roles;
    }
    const userInfo2 = {
      ...userInfoResponse,
      roles,
      sessionId: this.getLastMRHSessionCookie()
    };
    this.setUserInfoToCacheAndSessionStorage(userInfo2);
    return userInfo2;
  }
  /**
   * Tries to retrieve user information from storage on the front-end.
   * First from sessionStorage, if the feature exists. Otherwise a global window object.
   * @returns Promise that resolves to UserInfo or null, if nothing found.
   * @see UserInfo interface above.
   */
  // eslint-disable-next-line class-methods-use-this
  async getUserInfoFromSessionStorage() {
    if (sessionStorage_default.isAvailable) {
      const serializedUserInfo = sessionStorage_default.getItem(USER_INFO_SESSION_STORAGE_KEY);
      if (serializedUserInfo) {
        try {
          const userInfo2 = await JSON.parse(serializedUserInfo);
          return userInfo2;
        } catch (error) {
          logHandler.logWarning(
            `in getUserInfoFromSessionStorage: Failed to parse session storage user information: ${error}. Will try fetching from global object or service.`
          );
        }
      }
    }
    return null;
  }
  /**
   * Stores the user information in a cached object and in session storage.
   * @param userInfo - user info object.
   * @see UserInfo interface above.
   */
  setUserInfoToCacheAndSessionStorage(userInfo2) {
    this.userInfo = userInfo2;
    const serializedUserInfo = JSON.stringify(userInfo2);
    sessionStorage_default.setItem(USER_INFO_SESSION_STORAGE_KEY, serializedUserInfo);
  }
  /**
   * Retrieve signed on user information.
   *
   * First, we wait for any current fetches for the user info to settle before
   * we continue to retrieve the information.
   *
   * Once promises is settled, we try to fetch the user information:
   * 1. from a cached object on the instance.
   * 2. from session storage
   * 3. finally fetch the data from the server if it doesn't exist yet.
   * @returns Promise that resolves to UserInfo
   * @see UserInfo interface above.
   * @throws Error - fetch fail, string deserialization fail. Make sure to handle the potential for
   * errors. Given the use case, you may be able to default the user information needed (like affiliation).
   */
  async getUserInfo() {
    if (this.userInfoRequestPromise) {
      await this.userInfoRequestPromise;
    }
    if (this.userInfo) {
      return this.userInfo;
    }
    const sessionStorageUserInfo = await this.getUserInfoFromSessionStorage();
    if (sessionStorageUserInfo && this.isLastMRHSessionCookieUnchanged(sessionStorageUserInfo.sessionId)) {
      return sessionStorageUserInfo;
    }
    return this.initializeFetchOfUserInfo();
  }
  /**
   * Retrieve the organization type of the currently signed on user.
   * @returns Organization (ao | concord)
   * @throws Error - fetch fail, string deserialization fail. Make sure to handle the potential for
   * errors.
   */
  async getOrganization() {
    const userInfo2 = await this.getUserInfo();
    return userInfo2.organization;
  }
  /**
   * Get whether the signed on user has the AO Associate role or not.
   * @returns Promise that resolves to true if user is an AO Associate.
   */
  async isAoAssociate() {
    const userInfo2 = await this.getUserInfo();
    return userInfo2?.organization === "ao" && userInfo2?.roles?.includes(
      "AOASSOC"
      /* AoAssociate */
    );
  }
};

// node_modules/@anacapri/boons/chunks/anacapri-chunk.QAHNXNLH.js
var userInfo = new UserInfoService();
var UserInfoInstance_default = userInfo;

// src/components/icon/icon.css
var styles = i`:host {
  /* custom variable defaults so intellisense works and doesn't complain about being undefined, will be overridden in icon.ts */
  --ana-size: 32px;
  --ana-color: '';
  --ana-rotate: 0;
  --ana-bg-color: '';
  --ana-bg-radius: 0;

  display: inline-flex;
  justify-content: center;
  align-items: center;
  vertical-align: middle;
  background-color: var(--ana-bg-color);
  border-radius: var(--ana-bg-radius);
  font-style: normal;
  text-decoration: none;
}

.icon {
  display: inline-block;
  transition: transform 0.2s ease;
  transform: var(--ana-rotate);
}

.icon::before {
  height: var(--ana-size);
  width: var(--ana-size);
  font-size: var(--ana-size);
  color: var(--ana-color);
  font-family: 'FontAwesome';
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon.error::before {
  content: '\\f12a';
}

.icon.info::before {
  content: '\\f129';
}

.icon.dollar::before {
  content: '\\f155';
}

.icon.warning::before {
  content: '\\f071';
}

.icon.check::before {
  content: '\\f00c';
}

.icon.refresh::before {
  content: '\\f021';
}

.icon.close::before {
  content: '\\f00d';
}

.icon.settings::before {
  content: '\\f013';
}

.icon.caret::before {
  content: '\\f0d7';
}

.icon.chevron::before {
  content: '\\f078';
}

.icon.add::before {
  content: '\\f067';
}

.icon.user::before {
  content: '\\f007';
}

.icon.heart::before {
  content: '\\f004';
}

.icon.book::before {
  content: '\\f02d';
}

.icon.house::before {
  content: '\\f015';
}

.icon.search::before {
  content: '\\f002';
}

.icon.envelope::before {
  content: '\\f0e0';
}

.icon.leaf::before {
  content: '\\f06c';
}

.icon.bank::before {
  content: '\\f19c';
}

.icon.file::before {
  content: '\\f15b';
}

.icon.phone::before {
  content: '\\f095';
}

.icon.link::before {
  content: '\\f08e';
}

.icon.up-arrow::before {
  content: '\\f062';
}

.icon.down-arrow::before {
  content: '\\f063';
}

.icon.clone::before {
  content: '\\f24d';
}

.icon.exclamation::before {
  content: '\\f12a';
}

.icon-label {
  font-size: 0.75rem;
}

.icon-lob {
  display: flex;
  flex-direction: column;
  align-items: center;
}

@media (prefers-reduced-motion) {
  .icon {
    transition: none;
  }
}
`;
var icon_default = styles;

// src/components/icon/icon.ts
var Icon = class extends AnacapriElement {
  constructor() {
    super(...arguments);
    this.parser = new DOMParser();
    this.icon = ke``;
    this.isProposalContext = false;
    this.size = 32;
    this.bgShape = "circle" /* Circle */;
    this.rotate = 0;
    this.showLabel = false;
  }
  /**
   * For the ao icon, we don't allow color change, so having access to the underlying SVG isn't necessary. Also,
   * the SVG was exported differently than the business line icons, so importing it in the same way would make
   * the SVG code more complex. For these reasons we just use an `img` tag.
   * @returns <img> of AO Logo
   */
  getAoIcon() {
    return ke`
      <img
        title=${this.title || "Auto Owner's Insurance Logo"}
        alt="AO Logo"
        style="height: ${this.size}px; width: ${this.size}px"
        src="/aoenv/public/corp/aoui/v1/images/AOicon/AOiconFull.svg"
      />
    `;
  }
  /**
   * For the concord icon, we don't allow color change, so having access to the underlying SVG isn't necessary. Also,
   * the SVG was exported differently than the business line icons, so importing it in the same way would make
   * the SVG code more complex. For these reasons we just use an `img` tag.
   * @returns <img> of Concord Logo
   */
  getConcordIcon() {
    return ke`
      <img
        title=${this.title || "Concord Logo"}
        alt="Concord Logo"
        style="height: ${this.size}px; width: ${this.size}px"
        src="/aoenv/public/corp/aoui/v1/images/ConcordIcon/ConcordIcon.svg"
      />
    `;
  }
  /**
   * Get the AO_UI icons. These we have to fetch the content of and inline,
   * otherwise we wouldn't be able to change the color given the icon updates
   * in renew.
   * @returns promise that resolves to <svg> of line of business icon
   */
  async getLobIcon() {
    const iconMetadata = LobIconMetadata[this.name];
    if (iconMetadata) {
      let iconFileName = iconMetadata.iconName;
      if (this.isProposalContext) {
        iconFileName = iconMetadata.fileIconName;
      } else if (this.color === "smoke" /* Smoke */) {
        iconFileName = iconMetadata.secondaryIconName;
      } else if (this.color) {
        iconFileName = iconMetadata.classicIconName;
      }
      const iconFile = this.iconFile || await requestSvgIcon(`/aoenv/public/corp/aoui/v1/images/LOBicons/${iconFileName}.svg`);
      if (iconFile.ok) {
        const doc = this.parser.parseFromString(iconFile.svg || "", "text/html");
        const svgElement = doc.body.querySelector("svg");
        if (svgElement) {
          const title = document.createElementNS("http://www.w3.org/2000/svg", "title");
          title.textContent = this.title;
          svgElement.prepend(title);
          svgElement.style.height = this.size + "px";
          svgElement.style.width = this.size + "px";
          if (this.color) {
            svgElement.style.setProperty("--ao-icon-primary-color", getCssColorString(this.color));
          }
          return ke`<div class="icon-lob">
            ${fe(svgElement.outerHTML)}
            ${this.showLabel ? ke`<span class="icon-label" id="lob-icon-label">${iconMetadata.label}</span>` : D}
          </div>`;
        }
      }
    }
    return ke``;
  }
  getFontAwesomeIcon() {
    return ke`<span
      title=${this.title}
      class="icon ${this.name}"
      style="--ana-size: ${this.bgColor ? this.size * 0.75 : this.size}px;"
    ></span>`;
  }
  /**
   * Get the correct SVG icon given the icon's type.
   *
   * The reason we are targeting seemingly arbitrary classes and ids is because the SVGs themselves were not exported with
   * appropriate names for layers and paths. This probably should be fixed in the future, along with adding an appropriate
   * title to each icon.
   *
   */
  async applyIconChanges() {
    this.style.setProperty("--ana-size", `${this.size}px`);
    this.style.setProperty("--ana-color", getCssColorString(this.color));
    this.style.setProperty("--ana-bg-color", getCssColorString(this.bgColor));
    this.style.setProperty("--ana-rotate", `rotate(${this.rotate}deg)`);
    if (this.bgShape === "octagon" /* Octagon */) {
      this.style.removeProperty("--ana-bg-radius");
      this.style.clipPath = "polygon(30% 0%, 70% 0%, 100% 30%, 100% 70%, 70% 100%, 30% 100%, 0% 70%, 0% 30%)";
    } else if (this.bgShape === "circle" /* Circle */) {
      this.style.setProperty("--ana-bg-radius", "100%");
    } else {
      this.style.setProperty("--ana-bg-radius", `${this.size * 0.2}px`);
    }
    if (this.name === "ao" /* AO */ || this.name === "sig" /* ACIC */ || this.name === "organization" && (this.organization === "ao" /* AO */ || this.organization === "sig" /* ACIC */)) {
      this.icon = this.getAoIcon();
    } else if (this.name === "cgi" /* Concord */ || this.name === "organization" && this.organization === "cgi" /* Concord */) {
      this.icon = this.getConcordIcon();
    } else if (isLobIconName(this.name)) {
      this.icon = await this.getLobIcon();
    } else {
      this.style.height = "var(--ana-size)";
      this.style.width = "var(--ana-size)";
      this.icon = this.getFontAwesomeIcon();
    }
  }
  async connectedCallback() {
    super.connectedCallback();
    if (this.name === "organization" && !this.organization) {
      try {
        this.organization = await UserInfoInstance_default.getOrganization();
      } catch (e2) {
        Logger_default.logError(`[ana-icon]: Failed to fetch organization with UserInfo 
 ${e2}`);
        this.organization = "ao" /* AO */;
      }
      this.applyIconChanges();
    }
  }
  firstUpdated(changedProps) {
    super.firstUpdated(changedProps);
    if (this.name === void 0 || !(this.name === "organization" || this.name === "ao" || this.name === "cgi" || this.name === "sig" || isLobIconName(this.name) || Object.values(FAIcon).includes(this.name))) {
      throw Error(
        `[ana-icon]: a valid icon name is required:
	${[
          "ao",
          ...Object.values(FAIcon),
          ...Object.keys(LobIconMetadata)
        ].join("\n	")}`
      );
    }
    if (this.color && this.isProposalContext) {
      Logger_default.logWarning(
        "[ana-icon]: The property `color` is ignored for icons used with `isProposalContext` enabled."
      );
    }
    return this.applyIconChanges();
  }
  willUpdate(changedProperties) {
    if (changedProperties.has("name") || changedProperties.has("size") || changedProperties.has("color") || changedProperties.has("bgColor") || changedProperties.has("bgShape") || changedProperties.has("rotate")) {
      this.applyIconChanges();
    }
  }
  render() {
    return ke`${this.icon}`;
  }
};
Icon.styles = [base_default, icon_default];
__decorateClass([
  r()
], Icon.prototype, "iconFile", 2);
__decorateClass([
  r()
], Icon.prototype, "icon", 2);
__decorateClass([
  r()
], Icon.prototype, "organization", 2);
__decorateClass([
  n()
], Icon.prototype, "name", 2);
__decorateClass([
  n({ attribute: "is-proposal-context", type: Boolean })
], Icon.prototype, "isProposalContext", 2);
__decorateClass([
  n({ type: Number })
], Icon.prototype, "size", 2);
__decorateClass([
  n()
], Icon.prototype, "color", 2);
__decorateClass([
  n({ attribute: "bg-color" })
], Icon.prototype, "bgColor", 2);
__decorateClass([
  n({ attribute: "bg-shape" })
], Icon.prototype, "bgShape", 2);
__decorateClass([
  n({ type: Number })
], Icon.prototype, "rotate", 2);
__decorateClass([
  n({ attribute: "show-label", type: Boolean })
], Icon.prototype, "showLabel", 2);
Icon = __decorateClass([
  customElement_default("ana-icon")
], Icon);

export {
  UserInfoInstance_default,
  Icon
};
/*! Bundled license information:

lit-html/directives/unsafe-svg.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)
*/
